export default __webpack_public_path__ + "static/SadiaSaysTransparent-553d7218a257220322b1b62c9d1dce60.png";